var overArg = require('./_overArg');

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/lodash@4.18.1/~/lodash/_getPrototype.js
// module id = 191
// module chunks = 0